import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_1108 implements Validator {

    public static id = 'CTRL_1108';
    private message = 'error.ctr_1108';


    public LOG: LogService = new LogService(CTRL_1108);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_1108.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                let numLotMarche = rg.substr(rg.length - 1);
                const firstChamp = ctrl.value.rgCtrls.firstChamp.replace('INDEX_1108_1', numLotMarche);
                const secondChamp = ctrl.value.rgCtrls.secondChamp.replace('INDEX_1108_1', numLotMarche);
                const thirdChamp = ctrl.value.rgCtrls.thirdChamp.replace('INDEX_1108_1', numLotMarche);

                const firstChampNameWithStepId = map.get(firstChamp);
                const secondChampNameWithStepId = map.get(secondChamp);
                const thirdChampNameWithStepId = map.get(thirdChamp);

                const firstChampCtrl = form.controls[firstChampNameWithStepId];
                const secondChampCtrl = form.controls[secondChampNameWithStepId];
                const thirdChampCtrl = form.controls[thirdChampNameWithStepId];
                if ((firstChampCtrl.value === '' && secondChampCtrl === undefined && thirdChampCtrl === undefined) ||
                    (firstChampCtrl.value === '' && secondChampCtrl.value === null && thirdChampCtrl.value === null)) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}